import { useSysadmin } from '@air/sysadmin';

import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';

export const useCanViewImportHistory = (): boolean => {
  const { isInternal } = useSysadmin();
  const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();
  const { importHistoryEnabled } = useFeatureFlags();

  const canViewTasks = Boolean(workspacePermissions?.workspace.canViewTasks);

  return isInternal || (importHistoryEnabled && canViewTasks);
};
